import { useContext, useEffect, useLayoutEffect, useMemo, useState, useRef } from "react";
import Carosel from "../../../components/Carousel";
import CopyToClipboard from "react-copy-to-clipboard";

import MDEditor from "@uiw/react-md-editor";
import remarkGfm from "remark-gfm";
import remarkHtml from "remark-html";

import Profile from '../../../assets/icons/icon_profile.png';
import AI from '../../../assets/icons/icon_ai.png';

import Styles from "./loading/LoadingForm.module.css";
import Like from '../../../assets/icons/icon_like.png';
import Liked from '../../../assets/icons/icon_liked.png';
import Dislike from '../../../assets/icons/icon_dislike.png';
import Disliked from '../../../assets/icons/icon_disliked.png';
import Copy from '../../../assets/icons/icon_copy.png';
import Toggle from '../../../assets/icons/icon_folderble.png';
import Reload from '../../../assets/icons/icon_reload_grey.png';



import { convertToHtml, formatDateString } from "../../../utils/commonFunctions";
import { MyContext } from "../../../context/MyContext";
import { useMedia767 } from "../../../hooks/useMedia.js";

/**
 * 튜터 대화 히스토리 컴포넌트
 */
const Chat = ({ history,setHistory , storage, isFrame, fetching, handleClickReaction, handleCopy, handleSample, handleFloat, linkToPage, toggleRefs, feedbackRef, handleReloadAnswer, isReload }) => {
 
  
  const isMobile = useMedia767();

  const memoizedHistory = useMemo(() => history, [history])
  
  const { user, paramId, list } = useContext(MyContext);

  const [focusRef, setFocusRef] = useState(new Array(memoizedHistory?.length));
  const [idxOfItemOpendComment, setIdxOfItemOpendComment] = useState(null);
  const [selectedReaction, setSelectedReaction] = useState(null);

  const closeCommentBox = () => {
    console.log('????')
    setIdxOfItemOpendComment(null);
    setSelectedReaction(null);
  }
  
  const generateCopyText = (item) => {
    const chatItem = list.find(item => item.id === Number(paramId));
    if (!chatItem) return
    let text;
    text = `\n과학동아AiR. ${item.input_text} (${formatDateString(chatItem.created_at)})\n\n`;
    text += `${item.response}\n\n`
    text += `[참고자료]\n`

    if (Array.isArray(item.reference) && item.reference.length > 0 && chatItem) {

      item.reference.forEach(ref => {
        const lastPart = ref.url.split('/').pop(); // "C201208N011"
        const datePart = lastPart.substring(1, 7); // "201208"
        const year = datePart.substring(0, 4); // "2012"
        const ho = datePart.substring(4, 6); // "08"

        text += `${ref.medium} - ${ref.name} - ${year}년 ${ho}호 - ${ref.url}\n`;
        // text += `${ref.medium} - ${ref.name} - ${ref.url}\n`;
      });
    }
    return text;
  };

  const handleClickSlide = item => {
    const url = item?.url || item;
    if (url && typeof url === "string") {
      window.open(url, '_blank')
    }
  }

  useLayoutEffect(() => {
    if (history.length === 0) return

  }, [history])

  const _handleFloat = (e, idx) => {
    closeCommentBox();
    handleFloat(e, idx);
  }
  
  // profile img 업데이트
  const [imageData, setImageData] = useState({
    picture_data: user?.picture_data,
    picture_extension: user?.picture_extension,
  });

  useEffect(() => {
    if (user?.picture_data && user?.picture_extension) {
      setImageData({
        picture_data: user?.picture_data,
        picture_extension: user?.picture_extension,
      });
    }
  }, [user?.picture_data, user?.picture_extension])
  const toggleIntro = (item, idx) => {
    setHistory((prev) => {  
      const copy = [...prev];
      copy[idx] = {
        ...copy[idx],
        is_open: !copy[idx].is_open,
      }
      return copy;
    })
  }

  return (
    // memoizedHistory.map((item, idx) => {
       memoizedHistory.map((item, idx) => {
       if(isReload && fetching) {
        const lastIdx = memoizedHistory.length - 1;
        if(idx === lastIdx) return null;
      }
      const allChatImages = (Array.isArray(item.reference) && item.reference.length !== 0)
        ? item.reference.flatMap(refItem => refItem.image || []) // image가 없을 경우 빈 배열 반환
        : [];
      const targetUrl = (item.reference && item?.reference?.length > 0)? item.reference[0]?.url : "";

      return (
        <div className="chat-ls" key={`${item.response_id}-${idx}`}>
          <div className="chat-ques">
            <div className="flx-box">
              <div
                style={
                  (imageData?.picture_extension && imageData?.picture_extension)
                    ?
                    {
                      padding: 0
                    }
                    :
                    null
                }
                className="profile-wrp flx-box">
                <img
                  style={
                    (imageData?.picture_extension && imageData?.picture_extension)
                      ?
                      {
                        width: '31px',
                        height: '31px',
                        borderRadius: '50%'
                      }
                      :
                      null
                  }
                  src={(imageData?.picture_data && imageData?.picture_extension) ? `data:image/${imageData.picture_extension};base64,${imageData.picture_data}` : Profile}
                  // src={Profile}
                  alt="user-profile" />
              </div>
              <p>나</p>
            </div>
            <p className="chat-ques__txt break-all">{item.input_text}</p>
          </div>


          <div className="chat-ans flx-box" >

            <div className="chat-ans__lg" >
              <div className="flx-box">
                <div className="icon_wrp flx-box">
                  <img src={AI} alt="donga-icon" />
                </div>
                <p className="text-red">과학동아AiR</p>
              </div>
            </div>

            <div className="chat-ans__bg" >
              {
                // clario 일반  답변
                item.response && (item.action === 'chat' || item.action === 'stop')
                  ?
                  (
                    <div className="chat-ans__txt">
                      {typeof (item.response) === 'string'
                        ?
                        convertToHtml(item.response.replace(/†/g, ""))
                        :
                        item.response?.replace(/†/g, "")
                      }

                      {
                        // sub_action 값 DB 저장시 주석 해제 (이미지 검색시 참고자료 숨길 때)
                        //  ( allChatImages?.length > 0 && item?.sub_action !== "ImageSearch" ) && 
                         allChatImages?.length > 0 &&
                          <div className="chat-ans__refs flx-box">
                              <div className="ref-title">📂 이런 자료를 참고했어요.</div>
                              {
                                (isMobile || allChatImages?.length > 3)
                                ?
                                <Carosel slides={item.reference} chat={true} key={`${item.response_id}-${idx}`} handleClick={handleClickSlide} />
                                :
                                  <ul className="justify-evenly flex" style={{padding: 0}}>
                                    {
                                      allChatImages.map((imgItem, imgIdx) => (
                                        <li
                                          className={`list-none  bg-transparent m-[10px] ${targetUrl ? 'cursor-pointer' :''}`}
                                          key={`${imgItem.IMG_SRC}-${imgIdx}`}
                                          onClick={() => handleClickSlide(targetUrl)}
                                        >
                                          <img
                                            // ref={(el) => { imgRefs.current[newIdx] = el }}
                                            className="w-full max-w-[150px] rounded-[10px] h-[150px] max-h-[150px]"
                                            // style={slides.length === 1 ? { maxWidth: '200px' } : null}
                                            src={imgItem.IMG_SRC}
                                            alt="ref-img"
                                            key={imgItem.title + imgIdx}
                                          />
                                        </li>
                                      ))
                                    }
                                  </ul>
                              }
                          </div>
                      
                      }
                      
                    </div>
                  )

                  : item.action === 'rec'
                    ?
                    // 기사 추천
                    <div className="rec__box">
                      <ul className="rec__box-list">
                        <p className="rec__box-inform">{item.response}</p>
                        {
                          (Array.isArray(item.search_result) && item.search_result.length !== 0) &&
                          <Carosel slides={item.search_result} chat={true} search />
                        }
                      </ul>
                    </div>
                    : item.action === 'error'
                      ?
                      <div className="chat-ans__txt" >{item.response}</div>
                      // : (fetching && idx === memoizedHistory.length - 1)
                      //   ?
                      //   <Typing />
                      //   : null
                      // ===========
 :  (
                      <div className="w-full min-h-[50px]  py-3 border-b-[1px] border-[#DDDDDD]
                                      items-center justify-between cursor-pointer ">
                     
                        <div className="w-full flex flex-col mt-2 md:mt-4">
                        <MDEditor.Markdown 
                        className={`wmde-markdown ${Styles.markdownViewerStlye} text-black`}
                        source={item.response} 
                        remarkPlugins={[remarkGfm, remarkHtml]}
                        style={{
                          fontFamily: "var(--font-notosans)",
                          backgroundColor: 'transparent',
                          color: "var(--foreground)"
                        }}
                        />
                        {/* 
                         todo 이미지 확인 후 주석 해제 250613 
                        <div className="flex pt-12 pb-4 rounded-[10px] relative" style={(Array.isArray(item?.reference) && item?.reference?.length > 0 && item?.reference[0]?.image?.length > 0) ? null : { display: 'none' }}>
                          
                          {
                            Array.isArray(item?.reference) && item?.reference?.length !== 0 && item.reference[0]?.image?.length > 0
                            &&
                            <div className="absolute top-[17px] font-semibold text-base md:text-lg">📂 이런 자료를 참고했어요.</div>
                          }
                          {
                            (Array.isArray(item.reference) && item.reference.length !== 0 && item.reference[0].image?.length > 0) &&
                            <Carosel slides={item.reference} chat key={`${item.response_id}-${idx}`} handleClick={handleClickSlide} />
                          }
                        </div> */}
                        </div>
                      </div>
                    )
                      // ===========
              }
            </div>
          </div>
          {
            // (fetching && idx === memoizedHistory.length - 1)
            //   ?
            //   null
            //   :
              <div className="src-name flx-box">
                {
                  !isFrame
                  &&
                  <div className="usr-rct flx-box sep-elm" style={item.response === undefined ? { display: 'none' } : null}>
                    <div className="usr-rct__btn flx-box" >
                      <div className="usr-cp flx-box">
                        {
                          item &&
                          <CopyToClipboard text={generateCopyText(item)} onCopy={handleCopy}>
                            <img src={Copy} alt="copy-btn" className="crs-btn" />
                          </CopyToClipboard>
                        }
                      </div>
                      {/* {
                        item.action !== 'stop' && */}
                      <div className="usr-ch flx-box">
                        <img id={1} onClick={(e) => {
                          setIdxOfItemOpendComment(idx);
                          setSelectedReaction(1);
                          handleClickReaction(e, idx)
                        }} src={item?.user_eva?.simple_eva === 1 ? Liked : Like} alt="like-btn" className="crs-btn" />
                        <img id={0} onClick={(e) => {
                          setIdxOfItemOpendComment(idx);
                          setSelectedReaction(0);
                          handleClickReaction(e, idx)
                        }} src={item?.user_eva?.simple_eva === 0 ? Disliked : Dislike} alt="dislike-btn" className="crs-btn" />
                        {
                          ((memoizedHistory?.length - 1 === idx) && !storage) &&
                          <img className="crs-btn" src={Reload} alt='reload-answer' onClick={(e) => handleReloadAnswer(e, item)} />

                        }
                        {
                          (idxOfItemOpendComment === idx) &&
                          <FeedbackInput 
                            item={item}
                            idx={idx}
                            feedbackRef={feedbackRef}
                            handleFloat={_handleFloat}
                            setHistory={setHistory}
                            selectedReaction={selectedReaction}
                            closeCommentBox={closeCommentBox}
                          />
                        }
                      </div>
                      {/* } */}
                    </div>
                  </div>
                }
                {
                  (Array.isArray(item.reference) && item.reference?.length !== 0) &&
                  <div 
                  key={`${item?.response_id || item?.latency || item.response}-${idx}`}
                  className="more-btn crs-btn flx-box sep-elm dark-txt" 
                  onClick={() => toggleRefs(item, idx)}>
                    <img className={`${item.isShowDetail ? '' : 'reverse'}`} src={Toggle} alt="toggle-btn" />
                    <p className="dark-txt">{`참고 자료 ${item.isShowDetail ? '닫기' : '보기'}`}</p>
                  </div>
                }
              </div>
          }
          {
            item.isShowDetail &&
            <div className="ref-detail__wrp">
              {item.reference.map((temp, tempIdx) => (
                <div className={`ref-defail__item crs-btn ${focusRef[idx] === tempIdx ? 'focus' : ''}`} onClick={() => linkToPage(temp.url)}>
                  <div className="ref-detail__top flx-box">
                    <div className="ref-detail__title">{tempIdx + 1}. {temp.medium}</div>
                  </div>
                  <div className="ref-detail__bottom flx-box sep-elm">
                    <div className="left">
                      <p className="left-title">{temp.name}</p>
                      <p className="left-desc">{temp.summary}</p>
                    </div>
                    {
                      temp.image?.length > 0 &&
                      <div className="right">
                        <img alt="ref-img" src={temp.image?.length !== 0 ? temp.image[0].IMG_SRC : null} />
                      </div>
                    }
                  </div>
                </div>
              ))}
            </div>
          }
          {
            (Array.isArray(item.recommended_questions) && item.recommended_questions.length > 0)
            &&
            <div className="chat-ans__rec flx-box">

              <p className="chat-ans__rec-title">😀 이런 질문을 할 수 있어요!</p>

              {
                item.recommended_questions
                &&
                item.recommended_questions.map((recItem, recIdx) => {
                  return (
                    <div key={recItem} className="chat-ans__rec-txt cursor-pointer" onClick={() => handleSample(recItem)}>
                      {`Q. ${recItem}`}
                    </div>
                  )
                })
              }
            </div>
          }

        </div>
      )
    })
  )
}

const FeedbackInput = ({ item, idx, feedbackRef, handleFloat, setHistory, selectedReaction, closeCommentBox }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        closeCommentBox();
      }
    };

    // 윈도우에 클릭 이벤트 추가
    document.addEventListener('mousedown', handleClickOutside);
    
    // 컴포넌트 언마운트 시 이벤트 제거
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="flt-inp" ref={containerRef}>
      <div className="flt-inp__top">
        <p>{`어떤점이 마음에 ${selectedReaction === 1 ? '' : '안'}드셨나요?`}</p>
      </div>
      <input
        ref={(el) => { feedbackRef.current[idx] = el }}
        className="flt-inp__mid"
        defaultValue={selectedReaction === item.user_eva?.simple_eva ? item.user_eva?.eva : ''}
        placeholder="입력해주세요."
      />
      <div className="flt-inp__bt flx-box" onClick={(e) => handleFloat(e, idx)}>
        <button className="negative-btn crs-btn" id="cancel">취소</button>
        <button className='positive-btn crs-btn' id="save">저장</button>
      </div>
    </div>
  );
};export default Chat;